<template>
    <div class="cuadricula-container">
        <CajitaOscilo :osciloProp="oscilo" :vistaMapaProp="false" :vistaCuadriculaProp="true" :vistaDetalleProp="false"
            v-for="oscilo in oscilos" :key="oscilo.Id">
        </CajitaOscilo>
    </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import CajitaOscilo from './CajitaOscilo.vue';
import type { OsciloDetalleModel } from '@/.shared/.api';

const props = defineProps<{ oscilosProp: OsciloDetalleModel[] }>();
const oscilos = computed(() => props.oscilosProp.orderByDescending(x => x.IdOsciloEstadoTipo).thenBy(x => x.NombreInstalacion).thenBy(x => x.Nombre)); // cuando cambie props.oscilos, coge todos los items de la template donde se use dataSource y los recarga
</script>
<style scoped lang="scss">
@import "@/styles/_vars.scss";
@import "@/styles/figma.scss";
@import "@/styles/_themevars.scss";

.cuadricula-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: var(--spacing-md);
    grid-auto-rows: minmax(100px, auto);
}

@media (max-width: 991px) {
    .cuadricula-container {
        grid-template-columns: repeat(2, 1fr);
    }
}
</style>